import { Navigate, Route, Routes } from "react-router-dom";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import NotFoundPage from "../NotFoundPage/NotFoundPage";

import { MdAssignment, MdHome, MdBookmarks, MdBookmark } from 'react-icons/md';

import { useConfigContext } from "../../contexts/ConfigContext";
import { useInfoContext } from "../../contexts/InfoContext";
import { useTranslation } from "react-i18next";

import IndexPage from "./IndexPage/IndexPage";
import CareerPage from "./CareerPage/CareerPage";
import { getTranslation } from "../../services/translation";

const MainRouterPage = () => {
  const { lang } = useConfigContext();
  const { careers } = useInfoContext();

  const { t } = useTranslation();

  const pages = [
    {
      id: "home-page",
      title: t("header_home_text"),
      icon: <MdHome />,
      url: "/",
      loginReq: false,
      disabled: false,
      component: <IndexPage />,
    },
    {
      id: "my-schedule-page",
      title: t("header_my_schedule_text"),
      icon: <MdAssignment />,
      url: "/my-schedule",
      loginReq: true,
      disabled: false,
      component: <Navigate to="/app/my-schedule" />,
    },
    {
      id: "careers-pages",
      title: t("header_careers_text"),
      icon: <MdBookmarks />,
      pages: careers.map(career => ({
        id: `${career.code}_page`,
        title: getTranslation(career, "name", lang),
        icon: <MdBookmark />,
        loginReq: false,
        disabled: false,
        component: <CareerPage />,
        url: `/career/${career.uri}`
      }))
    },
  ];

  const flatRoutes = (pages = []) => {
    return pages.reduce((acc, page) => {
      return page.pages ? [...acc, ...flatRoutes(page.pages)] :
        [...acc, (
          <Route key={page.id} path={page.url} element={ page.component } />
        )];
    }, [])
  }

  return (
    <>
      <Header pages={pages} />
      <Routes>
        {flatRoutes(pages)}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default MainRouterPage;